import { inject, prop } from "fw";

import { AtsLoginForm } from "forms/ats-login";
import { dispatch } from "fw-state";

@inject
export class AtsLoginButton {
    @prop(null) label: string;
    @prop(null) organizationId: string;
    @prop(null) organizationName: string;
    @prop(null) impersonationOrganizationUserId: string;

    atsLoginForm: AtsLoginForm = null;
    loggingIn = false;
    hideValidation = false;

    created() {
        this.atsLoginForm = new AtsLoginForm();
        this.atsLoginForm.organizationId = this.organizationId;
        this.atsLoginForm.impersonationOrganizationUserId = this.impersonationOrganizationUserId;
    }

    get buttonLabel(): string {
        return this.label || "Impersonate";
    }

    async login() {
        this.loggingIn = true;

        await dispatch(this.atsLoginForm);

        this.loggingIn = false;
    }
}
